import http from './http'

export default {
    lists() {
        return http.get('mailchimp/lists')
    }
}